<template>
  <div>
    <div id="shouye"></div>
    <el-carousel
      :interval="2500"
      arrow="always"
      indicator-position="none"
      :height="bannerHeight + 'px'"
      data-aos="zoom-out"
      data-aos-offset="700"
      data-aos-delay="100"
      data-aos-duration="2000"
    >
      <el-carousel-item v-for="(item, index) in bannerlist" :key="index">
        <img
          :src="`http://www.bxy123.com/prod-api` + item.carouselImgPath"
          alt=""
          class="top_img"
         :style="{height: bannerHeight + 'px'}"
          @click="shiping(index,item.jumpType)"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="banner-wrap" v-if="videoshow">
      <img src="../assets/×@2x.png" alt="" class="banner_img" @click="guanbi" />
      <video
        id="myVideo"
        class="video-js vjs-big-play-centered i-video"
        controls="false"
        style="width: 95%"
      >
        <source :src="shipin" type="video/mp4" />
      </video>
    </div>

    <div class="top_box" :style="topBannerNavBg">
      <img src="../assets/logo2@2x.png" alt="" class="logo_img" />
      <div class="">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="transparent"
          text-color="#CDDBF6"
          active-text-color="#fff"
        >
          <el-menu-item index="shouye">首页</el-menu-item>
          <el-menu-item index="youshi">平台优势</el-menu-item>
          <el-menu-item index="xitong">系统搭建</el-menu-item>
          <el-menu-item index="xiaozhaomu">小节点招募</el-menu-item>
          <el-menu-item index="dazhaomu">大节点招募</el-menu-item>
          <el-menu-item index="yingjian">硬件产品</el-menu-item>
          <el-menu-item index="lianxi">联系商务</el-menu-item>
          <el-menu-item index="bangzhu">帮助中心</el-menu-item>
          <el-menu-item index="guanyu">关于我们</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div id="youshi"></div>
    <div></div>
    <div class="title_box">
      <img
        src="../assets/pingtai@2x.png"
        alt=""
        class="title_img"
        style="width: 460px"
      />
    </div>
    <div class="box" style="width: 80%">
      <div class="cont">
        <div
          class="cont_box"
          v-for="(item, index) in youshilist"
          :key="index"
          data-aos="zoom-in"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="4000"
        >
          <div style="width: 40%;height: 100px;">
            <img :src="item.img" alt=""  class="cont_img" />
          </div>
          <p class="cont_title">{{ item.title }}</p>
          <p class="cont_text">
            {{ item.text }}
          </p>
        </div>
      </div>
    </div>
    <div id="xitong"></div>
    <div class="xitong_box">
      <img src="../assets/bgimg@2x.png" alt="" class="xitong_img" />
      <div class="xitong_zuo">
        <p class="xitong_title">系统搭建</p>
        <div class="vertical-select">
          <ul>
            <li
              v-for="(item, index) in xitonglist"
              :key="index"
              @click="selectItem(index)"
              :class="{ selected: selectedIndex === index }"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <div class="xitong_you">
        <p class="xitong_name">{{ xitongdet.title }}</p>
        <div class="kuai"></div>
        <p class="xitong_wenben">
          {{ xitongdet.content }}
        </p>
      </div>
    </div>
    <!-- 系统搭建 -->

    <!-- 招募 -->
    <div id="xiaozhaomu"></div>
    <div class="title_box">
      <img src="../assets/xiaojiedian@2x.png" alt="" class="title_img" />
      <p class="title_text">
        200M以下带宽 适用产品形态展示一下
        机顶盒、路由器、摄像头、光猫电源等。。。
      </p>
    </div>
    <div class="zhaomu">
      <p class="zm_title">
        数据概览<span style="color: #5b8dfe">震撼人心</span>
      </p>
      <p class="zm_text">智能融合CDN</p>
      <img src="../assets/bolang6@2x.png" alt="" class="bolangimg" />
      <div class="tonyong" style="">
        <div style="text-align: center">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            "
          >
            <countTo
              :startVal="startVal"
              :endVal="shujulist.edgeNode"
              :duration="duration"
              :separator="separator"
              :autoplay="true"
              ref="example1"
              class="zm_num"
            >
            </countTo>
            <p class="zm_num" ref="countUp">
              <span style="font-size: 14px; margin-left: 5px">+</span>
            </p>
          </div>
          <p class="zm_name">边缘节点</p>
        </div>
        <div style="text-align: center">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            "
          >
            <countTo
              :startVal="startVal"
              :endVal="shujulist.bandwidthReserve"
              :duration="duration"
              :separator="separator"
              :autoplay="true"
              ref="example1"
              class="zm_num"
            >
            </countTo>
            <p class="zm_num" ref="countUp">
              <span style="font-size: 14px; margin-left: 5px">+</span>
            </p>
          </div>
          <p class="zm_name">带宽储备能力数量</p>
        </div>
        <div style="text-align: center">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            "
          >
            <countTo
              :startVal="startVal"
              :endVal="shujulist.signVideoManufacturer"
              :duration="duration"
              :separator="separator"
              :autoplay="true"
              ref="example1"
              class="zm_num"
            >
            </countTo>
            <p class="zm_num" ref="countUp">
              <span style="font-size: 14px; margin-left: 5px">+</span>
            </p>
          </div>
          <p class="zm_name">签约视频厂商</p>
        </div>
        <div style="text-align: center">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            "
          >
            <countTo
              :startVal="startVal"
              :endVal="shujulist.edgeStorage"
              :duration="duration"
              :separator="separator"
              :autoplay="true"
              ref="example1"
              class="zm_num"
            >
            </countTo>
            <p class="zm_num" ref="countUp">
              <span style="font-size: 14px; margin-left: 5px">+</span>
            </p>
          </div>
          <p class="zm_name">边缘存储</p>
        </div>
        <div style="text-align: center">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            "
          >
            <countTo
              :startVal="startVal"
              :endVal="shujulist.guaranteeRate"
              :duration="duration"
              :separator="separator"
              :autoplay="true"
              ref="example1"
              class="zm_num"
            >
            </countTo>
            <p class="zm_num" ref="countUp">
              <span style="font-size: 14px; margin-left: 5px">+</span>
            </p>
          </div>
          <p class="zm_name">保障机制</p>
        </div>
      </div>
      <p class="zm_title" style="margin-top: 91px">一站式边缘计算品牌孵化</p>
      <p class="zm_text" style="width: 637px">
        专业一对一品牌定制，为客户提供软硬件一站式边缘计算服务和解决方案，
        为中小企业提供边缘计算一站式服务解决方案。实现企业低成本，快速精准推广。
      </p>
      <img src="../assets/bolang6@2x.png" alt="" class="bolangimg" />
      <div class="tonyong" style="width: 60%">
        <div
          v-for="(item, index) in wuxulist"
          :key="index"
          style="text-align: center; display: flex; align-items: center"
        >
          <img src="../assets/dui@2x.png" alt="" class="zm_img" />
          <p class="zm_wenben">{{ item.text }}</p>
        </div>
      </div>

      <p class="zm_title" style="margin-top: 91px; margin-bottom: 24px">
        产品优势
      </p>
      <img src="../assets/bolang6@2x.png" alt="" class="bolangimg" />
      <div class="tonyong" style="width: 71%; justify-content: space-between">
        <div
          class="zm_box"
          data-aos="flip-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
        >
          <img src="../assets/TV35@2x.png" alt="" class="zm_tvimg" />
          <p class="zm_tvttle">电视直播功能</p>
          <p class="zm_tvtext">
            频道3000+央视 卫视 体育地方台 市县级频道 随心选择超清不卡段
            无需会员没有广告
          </p>
        </div>
        <div
          class="zm_box"
          data-aos="flip-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
        >
          <img
            src="../assets/jiangjie@2x.png"
            alt=""
            class="zm_tvimg"
            style="width: 65px; height: 61px"
          />
          <p class="zm_tvttle">名师讲解</p>
          <p class="zm_tvtext">
            从幼儿到高中课程辅导，同步全国教材名师 线上辅导联合多家教育机构
            涵盖各类课程全 部免费 思维早教 益智动脑，全学龄段课程。
          </p>
        </div>
        <div
          class="zm_box"
          data-aos="flip-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
        >
          <img
            src="../assets/dianying38@2x.png"
            alt=""
            class="zm_tvimg"
            style="width: 65px; height: 65px"
          />
          <p class="zm_tvttle">全网影视</p>
          <p class="zm_tvtext">
            电视剧 电影 综艺 动漫 少儿 体育 全网影视 资源 热播剧持续更新
          </p>
        </div>
      </div>
    </div>
    <!-- 总部支持 -->
    <div class="zonbu">
      <p class="zonbu_title">总部支持</p>
      <img src="../assets/bolang.png" alt="" class="bolangimg" />
      <div
        class="tonyong"
        style="
          width: 74%;
          justify-content: space-between;
          margin-top: 43px;
          height: 64%;
        "
      >
        <div
          v-for="(item, index) in zhichilist"
          :key="index"
          class="zonbu_box wow animate__animated animate__zoomInRight"
          data-wow-delay="0.5s"
          data-wow-duration="1s"
        >
          <p class="zb_title">{{ item.title }}</p>
          <div class="zb_xian"></div>
          <p class="zb_text">
            {{ item.text }}
          </p>
          <img :src="item.img" alt="" class="zb_img" />
        </div>
      </div>
    </div>
    <!-- 招募 -->
    <div id="dazhaomu"></div>
    <div class="title_box">
      <img src="../assets/tit.png" alt="" class="title_img" style="width: 600px;"/>
      <p class="title_text">X86 IDC机房</p>
    </div>
    <div class="zhaomu" style="height: 570px">
      <p class="zm_title" style="margin-top: 0px">全球边缘计算技术创新实践者</p>
      <p class="zm_text">
        使用个人IDC组件的CDN网络通过大数据云计算技术的高效调度，实现高效率、低成本的网络传输
      </p>
      <img src="../assets/bolang6@2x.png" alt="" class="bolangimg" />

      <div
        class="tonyong"
        style="width: 71%; justify-content: space-between; margin-top: 63px"
      >
        <div
          v-for="(item, index) in dazhaomulist"
          :key="index"
          style="display: flex; align-items: center; flex-direction: column"
        >
          <img :src="item.img" alt="" class="zuimg" />
          <p class="zutitle">{{ item.title }}</p>
          <p class="zutext">{{ item.text }}</p>
        </div>
      </div>
    </div>
    <div class="ditu_box">
      <div>
        <div style="display: flex; align-items: center; margin-bottom: 50px">
          <img src="../assets/ditudinwei@2x.png" alt="" class="du_dinwei" />
          <p class="du_dinweitext">遍布全国得边缘云节点</p>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            position: relative;
            justify-content: center;
            z-index: 9;
            margin-bottom: 80px;
          "
        >
          <img src="../assets/jiedian@2x.png" alt="" class="jiedian_img" />
          <div style="margin-left: -20px">
            <p class="jiedian_num">{{ jiedianlist.edgeNode }}+</p>
            <p class="jiedian_text">边缘节点</p>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            position: relative;
            justify-content: center;
            z-index: 9;
            margin-bottom: 80px;
          "
        >
          <img src="../assets/chnegshi@2x.png" alt="" class="jiedian_img" />
          <div style="margin-left: -20px">
            <p class="jiedian_num">{{ jiedianlist.cityCover }}+</p>
            <p class="jiedian_text">城市覆盖</p>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            position: relative;
            justify-content: center;
            z-index: 9;
            margin-bottom: 80px;
          "
        >
          <img src="../assets/quxian@2x.png" alt="" class="jiedian_img" />
          <div style="margin-left: -20px">
            <p class="jiedian_num">{{ jiedianlist.districtCover }}+</p>
            <p class="jiedian_text">区域覆盖</p>
          </div>
        </div>
      </div>
      <img src="../assets/map@2x.png" alt="" class="dt_img" />
    </div>
    <div
      style="
        width: 100%;
        min-height: 150px;
        background-color: #fff;
        padding-top: 60px;
        padding-bottom: 60px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
      "
    >
      <div
        class="yewu_box"
        data-aos="zoom-in"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="4000"

        v-for="(item, index) in yewulist"
        :key="index"
         v-if="index < 4"
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center">
            <img src="../assets/yewuicon13@2x.png" alt="" class="yewu_img" />
            <p class="yewu_title">{{ item.businessName }}</p>
          </div>
          <div class="yewu_btn" @click="tanchuang(item.id)">了解更多></div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            margin-top: 40px;
            margin-bottom: 26px;
          "
        >
          <p class="yewu_zhaomu">招募范围:</p>
          <p class="yewu_text">{{ item.recruitScope }}</p>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 26px">
          <p class="yewu_zhaomu">运营商:</p>
          <p class="yewu_text">{{ item.operator }}</p>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 26px">
          <p class="yewu_zhaomu">带宽要求:</p>
          <p class="yewu_text">{{ item.bandwidthDemand }}</p>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 26px">
          <p class="yewu_zhaomu">设备:</p>
          <p class="yewu_text">{{ item.device }}</p>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 26px">
          <p class="yewu_zhaomu">计费方式:</p>
          <p class="yewu_text">{{ item.chargingWay }}</p>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 26px">
          <p class="yewu_zhaomu">单价:</p>
          <p class="yewu_text">{{ item.unitPrice }}</p>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 26px">
          <p class="yewu_zhaomu"></p>
          <p class="yewu_tips" style="margin-left: 17px;">{{ item.otherRemark }}</p>
        </div>

        <!-- <img src="../assets/yewubgicon95@2x.png" alt="" class="yewu_bgimg" /> -->
      </div>
      <div class="dianji" @click="dinji">查看更多 ></div>
    </div>

    <!-- 硬件产品 -->
    <div id="yingjian"></div>
    <div class="title_box">
      <img
        src="../assets/yingjian@2x.png"
        alt=""
        class="title_img"
        style="width: 428px"
      />
      <div class="more_btn" @click="genduo">更多></div>
    </div>
    <div
      style="
        width: 100%;
        min-height: 150px;

        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
      "
    >
      <div
        class="canping_box"
        data-aos="zoom-in"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="4000"
        v-for="(item, index) in canpinglist"
        :key="index"
        v-if="index < 4"
      >
        <div style="text-align: center; margin-top: 28px; margin-left: 30px">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              /* background-color: #5b8dfe; */
            "
            class="img_box"
          >
            <img
              :src="`http://www.bxy123.com/prod-api` + item.productImgPath"
              alt=""
              style=""
              class="img_daxiao"
            />
          </div>
          <p class="canping_name">{{ item.productName }}</p>
        </div>
        <div style="margin-left: 33px">
          <div
            style="
              display: flex;
              align-items: center;
              margin-top: 63px;
              margin-bottom: 10px;
            "
          >
            <p class="canping_title">适配网络:</p>
            <p class="canping_text">{{ item.adaptNetwork }}</p>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <p class="canping_title">CPU配置:</p>
            <p class="canping_text">{{ item.cpuConfig }}</p>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <p class="canping_title">硬盘接口:</p>
            <p class="canping_text">{{ item.diskInterface }}</p>
          </div>

          <div style="display: flex; align-items: center; margin-bottom: 10px">
            <p class="canping_title">网口:</p>
            <p class="canping_text">{{ item.networkInterface }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="title_box">
      <img
        src="../assets/hezuo@2x.png"
        alt=""
        class="title_img"
        style="width: 449px"
      />
    </div>
    <div class="hezuo_box">
      <p class="hezuo_text">
        来自头部公司与上百家客户得合作信任与选择，<span style="color: #1d61dc"
          >一站式解决方案满足客户不同类型需求</span
        >
      </p>
      <img :src="`http://www.bxy123.com/prod-api` + hezuoimg" alt="" class="hezuo_img" />
    </div>
    <!-- 联系 -->
    <div id="lianxi"></div>
    <div class="title_box">
      <img
        src="../assets/lianxi@2x.png"
        alt=""
        class="title_img"
        style="width: 246px"
      />
    </div>
    <div style="display: flex; align-items: center; justify-content: center">
      <div
        class="lianxi_box"
        data-aos="zoom-in"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="4000"
      >
        <img src="../assets/lainxi(2)@2x.png" alt="" class="lianxi_img" />
        <div class="lianxi_top">
          <p class="lianxi_title">大节点合作</p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/dian558@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">适合大量带宽接入</p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/dian558@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">
            支持服务器、电脑、工作站、小主机、云主机、NAS等X86架构设备接入
          </p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/dian558@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">支持平台合作、代理等多种合作模式</p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/dian558@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">
            多对一服务，商务、技术多对一解决跑量、收益问题
          </p>
        </div>
        <div class="lianxi_kefu">
          <div class="kefu_box">
            <img
              src="../assets/lainxima563@2x.png"
              alt=""
              style="width: 135px"
            />
          </div>
          <p class="kefu_text">添加专属商务客服</p>
        </div>
      </div>

      <div
        class="lianxi_box"
        data-aos="zoom-in"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="4000"
      >
        <img src="../assets/dajidian@2x.png" alt="" class="lianxi_img" />
        <div class="lianxi_top">
          <p class="lianxi_title">小节点合作</p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/dian558@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">
            如有线上、线下铺货通道，可为念提供分销/代理服务
          </p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/dian558@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">
            如想搭建自由平台，可为您提供定制硬件供应链、API、小程序等配套服务
          </p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/dian558@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">如想批量购机，可为您提供优惠政策</p>
        </div>

        <div class="lianxi_kefu">
          <div class="kefu_box">
            <img
              src="../assets/lainxima563@2x.png"
              alt=""
              style="width: 135px"
            />
          </div>
          <p class="kefu_text">添加专属商务客服</p>
        </div>
      </div>

      <div
        class="lianxi_box"
        data-aos="zoom-in"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="4000"
      >
        <img src="../assets/dakehu@2x.png" alt="" class="lianxi_img" />
        <div class="lianxi_top">
          <p class="lianxi_title">大客户通道</p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/lainxima563@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">
            如有大批量OTT盒子、路由器、NAS、电脑主机等硬件设备，可为您提供多样化软件程序接入及API调用服务
          </p>
        </div>
        <div class="lianxi_row">
          <img
            src="../assets/lainxima563@2x.png"
            alt=""
            style="width: 8px; margin-top: 10px; margin-left: 40px"
          />
          <p class="lianxi_text">
            如想在自由生态中增加变现手段，可为您提供定制化合作方案
          </p>
        </div>

        <div class="lianxi_kefu">
          <div class="kefu_box">
            <img
              src="../assets/lainxima563@2x.png"
              alt=""
              style="width: 135px"
            />
          </div>
          <p class="kefu_text">添加专属商务客服</p>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="bottom">
      <div class="bottom_box">
        <div class="bottom_zuo">
          <img src="../assets/logo693@2x.png" alt="" class="bottom_logo" />
          <div style="display: flex; align-items: flex-start; flex-wrap: wrap">
            <div>
              <div style="display: flex; align-items: center; margin-top: 21px">
                <img src="../assets/dianhua@2x.png" alt="" width="34px" />
                <p class="bootom_text">15905341567</p>
              </div>
              <div style="display: flex; align-items: center; margin-top: 21px">
                <img src="../assets/dkw@2x.png" alt="" width="34px" />
                <p class="bootom_text">1871534@qq.com</p>
              </div>
            </div>
            <div class="bottom_jianju">
              <div style="display: flex; align-items: center; margin-top: 21px">
                <img src="../assets/weixin@2x.png" alt="" width="34px" />
                <p class="bootom_text">vxxcc888</p>
              </div>
              <div style="display: flex; align-items: center; margin-top: 21px">
                <img src="../assets/dizhi@2x.png" alt="" width="34px" />
                <p class="bootom_text">山东省德州市天衢新区宋官屯街道三八东路1735号东沿街0005栋楼6号 百姓云</p>
              </div>
            </div>
            <div>
              <div style="display: flex; align-items: center; margin-top: 21px;display: none">
                <img src="../assets/qq@2x.png" alt="" width="34px" />
                <p class="bootom_text">123456</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_you">
          <div style="text-align: center; display: none">
            <div class="bottom_mabox">
              <img src="../assets/web712@2x.png" alt="" class="bottom_ma" />
            </div>
            <p class="bottom_web">网页端</p>
          </div>
          <div style="text-align: center; margin-left: 24px">
            <div class="bottom_mabox" @click="openAppUrl">
              <img src="../assets/web712@2x.png" alt="" class="bottom_ma" />
            </div>
            <p class="bottom_web">APP</p>
          </div>
          <div style="text-align: center; margin-left: 24px; display: none">
            <div class="bottom_mabox">
              <img src="../assets/web712@2x.png" alt="" class="bottom_ma" />
            </div>
            <p class="bottom_web">小程序</p>
          </div>
        </div>
      </div>
      <div class="bottom_bt">
        <p class="bottom_text">
          Copyright © 2001-2025 百姓云计算（山东）有限公司 鲁ICP备2024057296号-2
        </p>
        <div style="display: flex; align-items: center">
          <img
            src="../assets/jinhui719@2x.png"
            alt=""
            style="width: 18px; margin-right: 10px"
          />
          <p class="bottom_text">鲁公网安备 0000001号</p>
        </div>
      </div>
    </div>

    <div class="pop_bg" v-if="show">
      <div class="pop_box">
        <div class="pop_row">
          <p class="pop_title">详细信息</p>
          <img
            src="../assets/×@2x.png"
            alt=""
            style="width: 20px; margin-right: 30px"
            @click="show = false"
          />
        </div>
        <div style="width: 85%; margin: 20px auto">
          <el-table
            :data="yewudet"
            border
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center', color: '#333' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column prop="businessName" label="专线业务需求">
            </el-table-column>
            <el-table-column prop="upwardDemand" label="上行要求">
            </el-table-column>
            <el-table-column prop="networkDemand" label="网络要求">
            </el-table-column>
            <el-table-column prop="updateTime" label="更新时间">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="xuanfu" v-if="xfshow" @click="handleSelect('shouye')">
   <img src="../assets/gotop@2x.png" alt=""  class="xf_img">
</div>


  </div>
</template>

<script>
import countTo from "vue-count-to";
export default {
  components: { countTo },
  data() {
    return {
      activeIndex: "shouye",
      activeIndex2: "1",
      bannerHeight: "0",
      topBannerNavBg: {
        backgroundColor: "",
      },
      startVal: 0,
      endVal: 10000,
      duration: 20000, // 持续时间
      separator: "", // 分隔符
      countToshhow: true,
      suffix: "+",
      options: [
        "机顶盒桌面系统",
        "跑量插件管理系统",
        "分润管理系统",
        "海量三方内容推荐",
        "定制固件",
        "X86镜像",
      ], // 可替换为动态数据源
      youshilist: [
        {
          title: "SAAS服务",
          img: require("../assets/SAAS@2x.png"),
          text: "一键快速部署，两个工作日极速上线，服务器免费，运维全包揽，企业轻松开启数字化进程实现高效运营",
        },
        {
          title: "稳固供应链",
          img: require("../assets/gonying15@2x.png"),
          text: "深耕行业，携手各方伙伴，与上下游伙伴紧密携手，构建稳固供应链，夯实根基，让合作更安心",
        },
        {
          title: "自主研发",
          img: require("../assets/yanfa@2x.png"),
          text: "强大兼容，公司产品适配 X86、ARM、Android，以及各类 Linux 内核平台，灵活部署，轻松应对多元场景",
        },

        {
          title: "多平台部署",
          img: require("../assets/bushu@2x.png"),
          text: "强大兼容，公司产品适配 X86、ARM、Android，以及各类 Linux 内核平台，灵活部署，轻松应对多元场景",
        },
        {
          title: "账单透明",
          img: require("../assets/zhangdan@2x.png"),
          text: "公司账单超透明，每日明细、设备详情、采购价格、跑量图全展示，让您对开支了如指掌，合作无忧",
        },
        {
          title: "技术支持",
          img: require("../assets/jishu@2x.png"),
          text: "专业团队随时待命，我们提供 24 小时技术支持，精准快速解决问题，为您的业务运转保驾护航。",
        },
        {
          title: "新手友好",
          img: require("../assets/xinshou@2x.png"),
          text: "新手也能轻松驾驭，从操作指南到一对一答疑，全程呵护。即使是行业小白，也能迅速成长，开启精彩业务之旅",
        },
        {
          title: "私人订制",
          img: require("../assets/dinzhi@2x.png"),
          text: "公司凭借专业团队，深入挖掘您的个性化需求，定制专属方案，为您打造独一无二的产品与服务体验。",
        },
      ],
      wuxulist: [
        {
          text: "无需经验",
        },
        {
          text: "无需技术",
        },
        {
          text: "快速上手",
        },
        {
          text: "免费培训",
        },
        {
          text: "全程扶持",
        },
        {
          text: "庞大市场红利",
        },
        {
          text: "持续收益",
        },
      ],
      zhichilist: [
        {
          title: "培训支持",
          text: "专业培训基地培训，从产品到售技 巧，提供提携完整得销售培训",
          img: require("../assets/zbimg1@2x.png"),
        },
        {
          title: "物料支持",
          text: "销售工具（话术，产品ppt、faq等） 宣传彩页、客户案例、海报等",
          img: require("../assets/wuliao53@2x.png"),
        },
        {
          title: "技术支持",
          text: "从咨询、设计、开发到部署、维护 的全流程一对一专业服务，确保每 个项目都能精心打造，满足客户的个 性化需求",
          img: require("../assets/jishu50@2x.png"),
        },
        {
          title: "硬件支持",
          text: "与众多硬件制造商的紧密协作下，成 功研发出多次高效、稳定的边缘计算 硬件设备，为企业的发展提供了强有 力的支持",
          img: require("../assets/yingjian51@2x.png"),
        },
      ],

      dazhaomulist: [
        {
          title: "免费上机接入",
          text: "秒上机",
          img: require("../assets/tu5@2x.png"),
        },
        {
          title: "多业务混跑",
          text: "视频点播、直播、游戏等",
          img: require("../assets/huanpao5@2x.png"),
        },
        {
          title: "多设备适配兼容",
          text: "XB6、ARM64/32等",
          img: require("../assets/jianrong5@2x.png"),
        },
        {
          title: "提现秒到账",
          text: "雄厚资金支持",
          img: require("../assets/tixian5@2x.png"),
        },
      ],
      selectedIndex: 0,
      bannerlist: [],
      xitonglist: [],
      xulei: 0,
      shujulist: {},
      jiedianlist: {},
      yewulist: [],
      canpinglist: [],
      hezuoimg: "",
      visible: true,
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
      ],
      show: false,
      yewudet: [],
      videoshow: false,
      xitongdet: {
        title: "",
        content: "",
      },
      shipin:'',
      xfshow:false
    };
  },
  mounted() {
    // 首次加载时,初始化高度
    this.screenWidth = window.innerWidth;
    this.bannerHeight = (600 / 1550) * this.screenWidth;
    // 窗口大小发生改变
    (window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.bannerHeight = (600 / 1550) * this.screenWidth;
    }),
      this.$AOS.init({
        offset: 200,
        duration: 600,
        easing: "ease-in-sine",
        delay: 100,
      });

    new this.$wow.WOW().init({
      boxClass: "wow",
      animateClass: "animate__animated",
      offset: 0,
      mobile: true,
      live: true,
    });

    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
  },
  created() {
    this.getlist();
    if (this.$route.query.type) {
      this.activeIndex = this.$route.query.type;
    } else {
      this.activeIndex = "shouye";
    }
  },
  methods: {
    genduo() {
      this.$router.push({ path: "/about/canping" });
    },
    dinji() {
      this.$router.push({ path: "/about/zhaomu" });
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // if (scrollTop > 1200) {
      //   if (this.countToshhow == true) {
      //     this.$refs.example1[0].start();
      //     this.$refs.example1[1].start();
      //     this.$refs.example1[2].start();
      //     this.$refs.example1[3].start();
      //     this.$refs.example1[4].start();

      //     this.countToshhow = false;
      //   }

      //   console.log(this.countToshhow);
      // }
      if (scrollTop) {
         this.xfshow = true
        this.topBannerNavBg.backgroundColor = "#3092FC"; // scrollTop + 多少根据自己的需求设置
      } else if (scrollTop === 0) {
        this.topBannerNavBg.backgroundColor = "transparent"; // 设置回到顶部时，背景颜色为透明
        this.xfshow = false
      }
    },
    // 滚动之前重置
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    handleSelect(key) {
      const element = document.getElementById(key);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // 启用平滑滚动
      }
      if (key == "bangzhu") {
        this.$router.push({ path: "/about/bangzhu" });
      }
      if (key == "guanyu") {
        this.$router.push({ path: "/about/AboutUs" });
      }
    },
    selectItem(index) {
      this.selectedIndex = index;
      this.$emit("selected", this.options[index]); // 将选中的值传递给父组件

      this.xulei = index;
      this.xitongdet.title = this.xitonglist[index].title;
      this.xitongdet.content = this.xitonglist[index].content;
    },
    // 轮播图点击是否播放视频
    shiping(index,type) {
      console.log(index);
      if (type == "1") {
        //  播放视频
        this.videoshow = true;
         this.shipin = 'http://www.bxy123.com/prod-api' + this.bannerlist[index].videoPath
      }
    },
    guanbi() {
      console.log("fkfkfk");
      this.videoshow = false;
    },
    tanchuang(id) {
      this.$axios({
        method: "get",
        url: this.ss + "businessDetailList/" + id,
      })
        .then((res) => {

          this.show = true;
          this.yewudet = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getlist() {

      this.bannerlist = []
      console.log( this.bannerlist)
      this.$axios({
        method: "get",
        url: this.ss + "carouselImgList",

        params:{
          PointCode:'PC'
        }
      })
        .then((res) => {
          res.data.data.forEach((ele)=>{
                if(ele.pointCode == 'PC' ){
                  this.bannerlist.push(ele)
                }
          })

        })
        .catch((error) => {
          console.log(error);
        });
      this.$axios({
        method: "get",
        url: this.ss + "systemSetupList",
        data: {},
      })
        .then((res) => {

          this.xitonglist = res.data.data;
          this.xitongdet.title = this.xitonglist[0].title;
          this.xitongdet.content = this.xitonglist[0].content;
        })
        .catch((error) => {
          console.log(error);
        });
      this.$axios({
        method: "get",
        url: this.ss + "smallNodeRecruitmentDetail",
        data: {},
      })
        .then((res) => {

          this.shujulist = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.$axios({
        method: "get",
        url: this.ss + "edgeCloudNodeDetail",
        data: {},
      })
        .then((res) => {

          this.jiedianlist = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.$axios({
        method: "get",
        url: this.ss + "privateLineBusinessMainList",
        data: {},
      })
        .then((res) => {

          this.yewulist = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.$axios({
        method: "get",
        url: this.ss + "hardwareProductsList",
        data: {},
      })
        .then((res) => {

          this.canpinglist = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
      this.$axios({
        method: "get",
        url: this.ss + "partnerDetail",
        data: {},
      })
        .then((res) => {

          this.hezuoimg = res.data.data.imgPath;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openAppUrl() {
      window.open("http://bxy_app_download.bxy123.com")
    }
  },
};
</script>
<style scoped lang="less">
.xf_img{
  display: block;
  width: 40px;
  height: 45px;
}
.xuanfu{
  width: 100px;
height: 100px;
background: #fff;
border-radius: 20px;
position: fixed;
right: 30px;
bottom: 100px;
z-index: 9999;
display: flex;
align-items: center;
justify-content: center;
}
.banner_img {
  width: 30px;
  position: absolute;
  right: 30px;
  top: 10px;
  z-index: 999;
}
.banner-wrap {
  width: 80%;
  height: 80vh;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  padding-top:20px ;
  padding-bottom: 20px;
  justify-content: center;
}
.dianji {
  cursor: pointer;
  width: 81%;
  height: 60px;
  background: #f6f8fa;
  border-radius: 10px;

  font-family: Microsoft YaHei;
  font-weight: 300;
  font-size: 16px;
  color: #000000;
  line-height: 60px;
  text-align: center;
}
.pop_bg {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;

  z-index: 999;
}
.pop_box {
  width: 70%;
  min-height: 160px;
  background: #fff;
  border-radius: 10px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;

  .pop_row {
    width: 100%;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #e9e9ea;
    .pop_title {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      margin-left: 30px;
    }
  }
}

.tonyong {
  width: 71%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 48px;
}
.xitong_box {
  width: 88%;
  height: 50vh;
  z-index: 9;
  display: flex;
  align-items: center;
  // background-color: #3973ca;
  // background-image: url("../assets/bgimg@2x.png");
  // background-position: center;
  // background-size: cover;
  // background-repeat: no-repeat;
  margin-top: 65px;
  position: relative;
  .xitong_img {
    width: 100%;
    position: absolute;
    z-index: 1;
  }
  .xitong_zuo {
    height: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    width: 200px;
    padding-left: 12%;
    .xitong_title {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 42px;
      color: #ffffff;
      z-index: 9;
      margin-bottom: 30px;
    }
    .vertical-select {
      z-index: 9;
    }
    .vertical-select ul {
      list-style-type: none;
      padding: 0;
      text-align: center;
    }

    .vertical-select li {
      cursor: pointer;
      padding-bottom: 8%;
      padding-top: 8%;
      padding-left: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #deebfe;
      margin-bottom: -1px;
      border-left: 1px solid rgb(226, 225, 225, 0.1);
      text-align: left;
    }

    .vertical-select .selected {
      color: white;
      border-left: 2px solid #fff;
    }
  }
  .xitong_you {
    width: 50%;
    height: 60%;
    // background-color: #3973ca;
    z-index: 9;
    margin-left: 13%;
    .xitong_name {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 26px;
      color: #000000;
    }
    .kuai {
      width: 37px;
      height: 4px;
      background-color: #5b8dfe;
      margin: 20px 0;
    }
    .xitong_wenben {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      line-height: 24px;
      text-indent: 2em;
    }
  }
}
.bottom {
  width: 100%;
  height: 402px;
  background-color: #404040;
  margin-top: 90px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .bottom_bt {
    width: 77.5%;
    height: 106px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    .bottom_text {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #cdcdcf;
    }
  }
  .bottom_box {
    width: 78.5%;
    height: 295px;
    border-bottom: 1px solid #595959;
    padding-top: 50px;
    box-sizing: border-box;
    display: flex;

    align-items: center;
    justify-content: space-between;
  }
  .bottom_jianju {
    margin-left: 79px;
  }
  .bottom_zuo {
    .bottom_logo {
      width: 26%;
      margin-bottom: 20px;
    }
    .bootom_text {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 20px;
      color: #ffffff;
      margin-left: 10px;
    }
  }
  .bottom_you {
    display: flex;
    align-items: center;

    .bottom_mabox {
      width: 160px;
      height: 160px;
      background: #fff;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .bottom_ma {
      width: 138px;
    }
    .bottom_web {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #cdcdcf;
      margin-top: 18px;
    }
  }
}

.lianxi_box {
  width: 25%;
  min-height: 604px;
  background: #ffffff;
  border-radius: 20px;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  .lianxi_img {
    position: absolute;
    top: 0;
    width: 100%;
  }
  .lianxi_top {
    width: 90%;
    height: 89px;
    border-bottom: 1px solid #e0ebf9;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .lianxi_title {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 28px;
      color: #3973ca;
      margin-left: 16px;
    }
  }
  .lianxi_row {
    display: flex;
    align-items: flex-start;
    margin-top: 28px;
    padding-right: 20px;
    .lianxi_text {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #000000;

      margin-left: 11px;
    }
  }
  .lianxi_kefu {
    display: flex;
    align-items: center;
    flex-direction: column;

    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    .kefu_box {
      width: 160px;
      height: 160px;
      border-radius: 20px;
      border: 1px solid #e5e7eb;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 29px;
    }
    .kefu_text {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #5b8dfe;
    }
  }
}
.hezuo_box {
  width: 77.5%;
  min-height: 66px;
  padding-bottom: 40px;
  background-color: #fff;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  .hezuo_text {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    margin-top: 90px;
    margin-bottom: 46px;
  }
  .hezuo_img {
    width: 73%;
  }
}
.canping_box {
  width: 40%;
  min-height: 109px;
  background: #fff;
  border-radius: 20px;
  margin-right: 20px;
  margin-left: 20px;
  margin-top: 43px;
  padding-bottom: 43px;
  display: flex;
  overflow: hidden;
  .img_box {
    width: 235px;
    height: 208px;
  }
  .img_daxiao {
    width: 212px;
    height: 208px;
  }
  .canping_name {
    margin-top: 8px;
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
  }
  .canping_title {
    width: 80px;
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }
  .canping_text {
    margin-left: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
  }
}
.more_btn {
  cursor: pointer;
  width: 96px;
  height: 32px;
  border-radius: 16px;
  border: 1px solid #e0e0e0;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 32px;
  margin: 27px auto 20px;
}
.yewu_box {
  width: 40%;
  height: 490px;
  background: #f6f8fa;
  border-radius: 20px;
  margin-bottom: 40px;
  margin-right: 20px;
  margin-left: 20px;
  padding-top: 42px;
  padding-left: 35px;
  padding-right: 10px;
  box-sizing: border-box;
  position: relative;

  .yewu_bgimg {
    width: 266px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .yewu_img {
    width: 9px;
    height: 28px;
  }
  .yewu_title {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 28px;
    color: #000000;
    margin-left: 12px;
  }
  .yewu_btn {
    cursor: pointer;
    width: 120px;
    height: 32px;
    // background: #5B8DFE;
    border-radius: 16px;
    border: 1px solid #5b8dfe;
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: 300;
    font-size: 16px;
    color: #5b8dfe;
    line-height: 32px;
    margin-right: 23px;
  }
  .yewu_zhaomu {
    width: 70px;
    display: block;
    text-align: right;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
    // background-color: #5B8DFE;
  }
  .yewu_text {
    font-family: Microsoft YaHei;
    font-weight: 300;
    font-size: 16px;
    color: #000000;
    margin-left: 17px;
  }
  .yewu_tips {
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    color: #5b8dfe;
  }
}

.yewu_box:hover {
  transform: rotateY(360deg);
}
.jiedian_img {
  width: 324px;
  height: 102px;
  position: absolute;
  z-index: -1;
  left: -40px;
}
.jiedian_num {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 28px;
  color: #faff00;
}
.jiedian_text {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
}
.ditu_box {
  width: 100%;
  height: 630px;
  background-image: url("../assets/ditu80@2x.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .dt_img {
    width: 45.8%;

    margin-top: 140px;
    animation-name: scaleDraw;
    /*关键帧名称*/
    animation-timing-function: ease-in-out;
    /*动画的速度曲线*/
    animation-iteration-count: infinite;
    /*动画播放的次数*/
    animation-duration: 10s;
  }

  @keyframes scaleDraw {
    /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
    0% {
      transform: scale(1);
      /*开始为原始大小*/
    }

    25% {
      transform: scale(1.1);
      /*放大1.1倍*/
    }

    50% {
      transform: scale(1);
    }

    75% {
      transform: scale(1.1);
    }
  }

  .du_dinwei {
    width: 10%;
  }
  .du_dinweitext {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 28px;
    color: #ffffff;
  }
}

.zuimg {
  width: 145px;
  height: 165px;
}
.zuimg:hover {
  transform: scale(1.2);

  -webkit-transform: scale(1.2);

  -moz-transform: scale(1.2);

  -o-transform: scale(1.2);

  -ms-transform: scale(1.2);
}
.zutitle {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 28px;
  color: #000000;
  margin-top: 31px;
  margin-bottom: 14px;
}
.zutext {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #757575;
}
.zonbu {
  width: 100%;
  height: 668px;
  background-image: url("../assets/zongbubgimg49@2x.png");
  background-repeat: no-repeat;
  // background-size: 100%;
  background-position: center; /* 图片居中 */
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 63px;
  box-sizing: border-box;

  .zonbu_title {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #ffffff;
    margin-bottom: 24px;
  }
  .zonbu_box {
    width: 24%;
    height: 100%;
    background-color: #fff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 47px;
    box-sizing: border-box;
    position: relative;
    z-index: 9;
    .zb_img {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 86%;

      z-index: -1;
    }
    .zb_title {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 28px;
      color: #000000;
    }
    .zb_xian {
      width: 43px;
      height: 2px;
      background-color: #6496ec;
      margin-top: 14px;
      margin-bottom: 26px;
    }
    .zb_text {
      padding: 0 10%;
      display: block;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      line-height: 28px;
    }
  }
}
.zhaomu {
  width: 100%;
  height: 1190px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 67px;
  box-sizing: border-box;
  .zm_title {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #000000;
  }
  .zm_text {
    display: block;
    margin-top: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #757575;
    margin-bottom: 15px;
    text-align: center;
  }
  .zm_name {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #757575;
  }
  .zm_num {
    display: flex;
    align-items: center;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    font-size: 30px;
    color: #5b8dfe;
  }
  .zm_img {
    width: 27px;
    height: 25px;
  }
  .zm_wenben {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 20px;
    color: #000000;
    margin-left: 8px;
  }
  .zm_box {
    width: 31%;
    height: 325px;
    // padding-bottom: 40px;
    background: #f6f8fa;
    border-radius: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 56px;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .zm_tvimg {
    width: 74px;
    height: 64px;
    transition: transform 0.5s;
  }
  .zm_box:hover .zm_tvimg {
    transform: rotateY(360deg);
  }

  .zm_tvttle {
    display: block;
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 28px;
    color: #000000;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .zm_tvtext {
    padding: 0 10%;
    display: block;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #757575;
    text-align: center;
  }
}

.bolangimg {
  width: 93px;

  display: block;
  margin: 0;
}

.top_img {
  width: 100%;
}
.top_box {
  position: fixed;
  width: 100%;
  height: 66px;

  /* background-color: rgb(6, 36, 26); */
  top: 0;
  z-index: 999;
  padding-left: 41px;
  padding-right: 58px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo_img {
  width: 10%;
}
.el-menu.el-menu--horizontal {
  border: none;

  .el-menu-item {
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    margin-left: 40px;
    width: none;
    padding: 0;
    height: none;
  }
  .el-menu-item:hover {
    background: none !important;
    color: #fff !important;
  }
}
.title_box {
  margin: 72px auto 62px;
  width: 100%;
  text-align: center;
  .title_img {
    width: 537px;
    height: 62px;
    display: block;
    margin: 0 auto;
  }
  .title_text {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #757575;
    display: block;
    margin-top: 17px;
  }
}
.box {
  width: 71%;
  //  background-color: #757575;
  margin: 0 auto;
}
.cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.cont_box {
  width: 22.5%;
  height: 300px;
  background-color: #fff;
  border-radius: 15px;
  // box-shadow: -3px 3px 3px -2px #aaa, 3px 3px 3px -2px #aaa;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  flex-direction: column;
  // margin-right: 15px;
  // margin-left: 15px;
  position: relative;
}
.cont_img {
  width: 76px;
  display: block;
  margin: 40px auto 0;

  transition: transform 0.5s;
}

.cont_box:hover .cont_img {
  transform: scale(1.2);
}
.cont_title {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 26px;
  color: #000000;
  display: block;
  margin-top: 30px;
}
.cont_text {
  padding: 0 5%;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #757575;

  display: block;
  margin-top: 27px;
}

@media all and (max-width: 1600px) {
  .zuimg {
    width: 125px;
    height: 145px;
  }

  .zutitle {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 20px;
    color: #000000;
    margin-top: 31px;
    margin-bottom: 14px;
  }
  .zutext {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #757575;
  }
  .zhaomu {
    .zm_title {
      font-size: 24px;
    }
    .zm_text {
      font-size: 14px;
    }
    .zm_img {
      width: 24px;
      height: 22px;
    }
    .zm_wenben {
      font-size: 16px;
    }
  }
  .cont_text {
    font-size: 12px;
  }
  .cont_title {
    font-size: 22px;
  }
  .zm_box {
    .zm_tvttle {
      font-size: 22px;
    }
    .zm_tvtext {
      font-size: 12px;
    }
  }
  .zonbu {
    .zonbu_box {
      .zb_title {
        font-size: 22px;
      }
      .zb_text {
        font-size: 12px;
      }
    }
  }
  .jiedian_text {
    font-size: 12px;
  }
  .jiedian_num {
    font-size: 24px;
  }
  .ditu_box {
    .du_dinweitext {
      font-size: 24px;
    }
  }
  .hezuo_box {
    .hezuo_text {
      font-size: 16px;
    }
  }
  .lianxi_box {
    .lianxi_top {
      .lianxi_title {
        font-size: 24px;
      }
    }
    .lianxi_row {
      .lianxi_text {
        font-size: 14px;
      }
    }
  }
  .bottom {
    .bottom_bt {
      .bottom_text {
        font-size: 12px;
      }
    }
    .bottom_box {
      .bottom_zuo {
        .bootom_text {
          font-size: 14px;
        }
      }
      .bottom_you {
        .bottom_mabox {
          width: 100px;
          height: 100px;
        }
        .bottom_ma {
          width: 80px;
        }
      }
    }
    .bottom_jianju {
      margin-left: 30px;
    }
  }
  .el-menu.el-menu--horizontal {
    .el-menu-item {
      font-size: 16px;
    }
  }
  .canping_box {
    .img_box {
      width: 185px;
      height: 158px;
    }
    .img_daxiao {
      width: 162px;
      height: 158px;
    }
    .canping_name {
      font-size: 18px;
    }
    .canping_title {
      font-size: 14px;
    }
    .canping_text {
      font-size: 14px;
    }
  }
  .xitong_box {
    height: 40vh;
    margin-top: 8%;

    .xitong_zuo {
      .xitong_title {
        font-size: 28px;
      }
      .vertical-select li {
        font-size: 10px;
      }
    }
    .xitong_you {
      width: 50%;
      height: 70%;

      z-index: 9;
      margin-left: 8%;
      .xitong_name {
        font-size: 22px;
      }
      .xitong_wenben {
        font-size: 14px;
      }
    }
  }
  .xf_img{
  display: block;
  width: 20px;
  height: 25px;
}
.xuanfu{
  width: 80px;
height: 80px;

}
}
</style>
